
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DegreePlan_PlannedSegmentCourses"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerPlan_PlannedSegmentCourse"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"needsReplan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availabilityUnconfirmed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"personalizedSegmentCourse"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseCurriculum_PersonalizedSegmentCourse"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DegreePlan_TermPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerPlan_TermPlan"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedTermId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estimatedTermName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkedTerm"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseCurriculum_AcademicTerm"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"skipped"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exceedsTimeAllowed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoCorrected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plannedSegmentCourses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DegreePlan_PlannedSegmentCourses"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DegreePlan_LearnerPlanResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerPlan_LearnerPlanResult"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerPlan"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DegreePlan_TermPlan"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":644}};
    doc.loc.source = {"body":"#import \"./dpmSharedFragments.graphql\"\n\nfragment DegreePlan_PlannedSegmentCourses on LearnerPlan_PlannedSegmentCourse {\n  needsReplan\n  availabilityUnconfirmed\n  personalizedSegmentCourse {\n    ...UseCurriculum_PersonalizedSegmentCourse\n  }\n}\n\nfragment DegreePlan_TermPlan on LearnerPlan_TermPlan {\n  estimatedTermId\n  estimatedTermName\n  linkedTerm {\n    ...UseCurriculum_AcademicTerm\n  }\n  skipped\n  exceedsTimeAllowed\n  autoCorrected\n  plannedSegmentCourses {\n    ...DegreePlan_PlannedSegmentCourses\n  }\n}\n\nfragment DegreePlan_LearnerPlanResponse on LearnerPlan_LearnerPlanResult {\n  learnerPlan {\n    ...DegreePlan_TermPlan\n  }\n  version\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./dpmSharedFragments.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DegreePlan_PlannedSegmentCourses"] = oneQuery(doc, "DegreePlan_PlannedSegmentCourses");
        
        module.exports["DegreePlan_TermPlan"] = oneQuery(doc, "DegreePlan_TermPlan");
        
        module.exports["DegreePlan_LearnerPlanResponse"] = oneQuery(doc, "DegreePlan_LearnerPlanResponse");
        
